export default __webpack_public_path__ + "static/media/contact-1.f9e9fda3.webp";